// Mock data for Vedyah Exim

export const company = {
  name: 'Vedyah Exim',
  tagline: 'Global Partner In Movements',
  director: 'Palak Shah',
  phone: '+91 7984338715',
  phoneRaw: '917984338715',
  email: 'info@vedyahexim.com',
  website: 'www.vedyahexim.com',
  logo: '/images/android-chrome-512x512.png',
  address: {
    headOffice: {
      name: 'Head Office',
      line1: '7/33-34, Sharda Sadan',
      line2: 'Near Central Bus Stand, Railway Station Road',
      city: 'Surat - 395003',
      state: 'Gujarat, India'
    },
    forwardingOffice: {
      name: 'Forwarding Office',
      line1: '34-A/1, Adani Port Road',
      line2: 'Hazira, Choryashi',
      city: 'Surat - 394270',
      state: 'Gujarat, India'
    }
  },
  certified: 'ISO 9001:2015 Certified',
  // Add full profile URLs here (e.g. 'https://www.linkedin.com/company/...'); icons with an empty URL are hidden.
  social: { facebook: '', linkedin: '', instagram: '' }
};

export const slides = [
  {
    title: 'Possibility In Every Direction',
    subtitle: 'For us Safety comes first.',
    image: 'https://images.unsplash.com/photo-1578575437130-527eed3abbec?q=80&w=1920&auto=format&fit=crop'
  },
  {
    title: 'Global Partner In Movements',
    subtitle: 'Making you move Ahead',
    image: 'https://images.unsplash.com/photo-1605745341112-85968b19335b?q=80&w=1920&auto=format&fit=crop'
  },
  {
    title: 'Time Effective Movements',
    subtitle: 'We deliver on time.',
    image: 'https://images.unsplash.com/photo-1519003722824-194d4455a60c?q=80&w=1920&auto=format&fit=crop'
  },
  {
    title: 'Each Container Handled Carefully',
    subtitle: 'For us Safety comes first.',
    image: 'https://images.unsplash.com/photo-1494412519320-aa613dfb7738?q=80&w=1920&auto=format&fit=crop'
  },
  {
    title: 'Trusted Freight Solutions',
    subtitle: 'End-to-end supply chain expertise.',
    image: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?q=80&w=1920&auto=format&fit=crop'
  }
];

export const aboutParagraphs = [
  'Vedyah Exim is a freight forwarding and logistics company based in Hazira, Gujarat, established with a clear vision of making international logistics simpler, more efficient, and customer-focused.',
  'As a sister company of Hazira Container Freight Station (HCFS), Vedyah Exim brings together logistics expertise, industry knowledge, and strong operational capabilities to provide customers with end-to-end logistics solutions under one roof.',
  'Our vision is to simplify the entire import and export process by providing customers with a single point of contact for their logistics requirements. From freight forwarding and customs clearance to CFS services, transportation, and other related logistics activities, we coordinate the complete movement of cargo while ensuring smooth communication and efficient execution.',
  'At Vedyah Exim, we understand that logistics involves multiple stakeholders, and communication between them can often become complicated. We aim to bridge that gap by offering easy communication, quick coordination, transparent processes, and personalized service.',
  'With our connection to HCFS and our growing network of logistics partners, we are committed to delivering competitive freight solutions, reliable services, and seamless cargo movement for businesses of all sizes.'
];

export const ourServices = [
  { name: 'Freight & Forwarding', icon: 'Ship' },
  { name: 'Custom Clearance', icon: 'FileCheck' },
  { name: 'Container Freight Station', icon: 'Container' },
  { name: 'Warehousing', icon: 'Warehouse' },
  { name: 'Project Cargo (ODC)', icon: 'Package' },
  { name: 'Transportation', icon: 'Truck' }
];

export const scopeOfWork = [
  { name: 'Freight Rail Transport', icon: 'TrainFront' },
  { name: 'Motorised Road Freight Transport', icon: 'Truck' },
  { name: 'Warehousing (Non-Refrigerated)', icon: 'Warehouse' },
  { name: 'Storage & Warehousing: general merchandise, furniture, automobiles, gas and oil, chemicals, textiles and goods in foreign trade zones', footerName: 'Storage & Warehousing', icon: 'Boxes' },
  { name: 'Other Land Transport Services', icon: 'Route' },
  { name: 'Cargo Handling Incidental to Land Transport', icon: 'PackageOpen' },
  { name: 'Shipping Cargo Agent Activities', icon: 'Ship' },
  { name: 'Management Consultancy Activities', icon: 'Briefcase' }
];

export const serviceCards = [
  {
    title: 'Freight & Forwarding',
    desc: 'Air, sea and multimodal freight forwarding solutions with global partners, ensuring the best routes and rates for your cargo.',
    image: 'https://images.unsplash.com/photo-1578575437130-527eed3abbec?q=80&w=1200&auto=format&fit=crop',
    icon: 'Ship'
  },
  {
    title: 'Custom Clearance',
    desc: 'Licensed custom broking services with in-depth regulatory expertise for hassle-free import/export clearances.',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=1200&auto=format&fit=crop',
    icon: 'FileCheck'
  },
  {
    title: 'Container Freight Station',
    desc: 'Fully equipped CFS operations with container yards, modern handling equipment and secure storage for seamless cargo movement.',
    image: 'https://images.unsplash.com/photo-1494412574643-ff11b0a5c1c3?q=80&w=1200&auto=format&fit=crop',
    icon: 'Container'
  },
  {
    title: 'Warehousing',
    desc: 'Secure warehousing and inventory management with modern facilities, ensuring your goods are stored safely and efficiently.',
    image: 'https://images.unsplash.com/photo-1587293852726-70cdb56c2866?q=80&w=1200&auto=format&fit=crop',
    icon: 'Warehouse'
  },
  {
    title: 'Project Cargo (ODC)',
    desc: 'End-to-end project cargo movement with specialized equipment, meticulous planning and safe execution for over-dimensional consignments.',
    image: 'https://images.unsplash.com/photo-1605745341112-85968b19335b?q=80&w=1200&auto=format&fit=crop',
    icon: 'Package'
  },
  {
    title: 'Transportation',
    desc: 'Reliable inland transportation across India with a well-maintained fleet, GPS tracking and on-time delivery commitment.',
    image: 'https://images.unsplash.com/photo-1519003722824-194d4455a60c?q=80&w=1200&auto=format&fit=crop',
    icon: 'Truck'
  }
];

export const directors = [
  {
    name: 'Palak Shah',
    designation: 'Director',
    photo: '/images/palak-shah.png',
    quote: 'Our vision at Vedyah Exim is to provide end-to-end logistics solutions under one roof. With a single point of contact, we simplify communication and ensure seamless coordination. Our goal is to make logistics simple, efficient, and hassle-free for every client.'
  },
  {
    name: 'Krupali Shah',
    designation: 'Director',
    photo: '/images/krupali-shah.png',
    quote: "At Vedyah Exim, we believe logistics should be seamless, not scattered. That's why we integrated Customs Clearance, CFS & Transportation under one roof - to give you one partner, from port to doorstep."
  }
];

// Shipping lines shown in the logo slider. Only keep lines you really work with.
// Logo file for each name = /images/brands/<name-in-lowercase-with-dashes>.png (or .svg / .webp / .jpg), e.g. maersk.png
// To add another line (MSC, OOCL, HMM, Yang Ming, PIL, Wan Hai...): add its name here and drop its logo file in that folder.
// url = website that opens (in a new tab) when the logo is clicked.
export const brands = [
  { name: 'MAERSK', url: 'https://www.maersk.com/' },
  { name: 'CMA CGM', url: 'https://www.cma-cgm.com/' },
  { name: 'HAPAG-LLOYD', url: 'https://www.hapag-lloyd.com/en/home.html' },
  { name: 'ONE', url: 'https://www.one-line.com/en' },
  { name: 'COSCO SHIPPING', url: 'https://lines.coscoshipping.com/home' },
  { name: 'EVERGREEN', url: 'https://www.evergreen-marine.com/' },
  { name: 'ZIM', url: 'https://www.zim.com/' },
  { name: 'MSC', url: 'https://www.msc.com/' },
  { name: 'KMTC', url: 'https://www.kmtc.co.kr/' },
  { name: 'TS LINE', url: 'https://www.tslineindia.com/' },
  { name: 'HMM', url: 'https://www.hmm21.com/company.do' },
  { name: 'GOODRICH', url: 'https://goodrich.co/' },
  { name: 'WANHAI', url: 'https://www.wanhai.com/' }
];

export const stats = [
  { value: '3+', label: 'Years of Experience' },
  { value: '100+', label: 'Happy Clients' },
  { value: '15+', label: 'Countries Served' },
  { value: '5K+', label: 'Shipments Delivered' }
];
